module.exports = "/static/assets/a5410e8125f778e01f7b4fc5da269033.png";